<template>
  <div class="page">
    <side-icons />
    <section class="section no-padding-bottom">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title margin-bottom-30px">Awards</h3></div>
      <ol class="text-normal list no-padding-top no-padding-bottom">
        <li>Citation Award (HKBU, 2015)</li>
        <li>Student Paper Prize (Xiaohao Cai, 1st Prize, East Asia SIAM Conference,Indonesia, 2013, co-author)</li>
        <li>Advanced Individual Research Award (Shenzhen, China, 2012)</li>
        <li>HKBU Research Incentive Award (2010, 2011, 2012)</li>
        <li>BDI-CNRS Scholarship (2004-2007), France</li>
        <li>Scholarship of Foundation (2001-2004), Ecole Polytechnique, France</li>
        <li>Honorable Mention in the Mathematical Contestin Modeling (1999), Consortium for Mathematics and Its Applications, USA</li>
        <li>Honorable Mention inthe Chinese Mathematical Contest in Modeling (1998)</li>
        <li>Geru Zheng Fellowship (1997-1998), Peking University</li>
        <li>New Student Scholarship (1996-1997), Peking University</li>
        <li>Honorable Mention in Chinese Mathematical Olympiad (1996)</li>
        <li>Third Prize in Chinese Mathematical Olympiad (1995)</li>
        <li>Outstanding Merit in the Chinese Mathematics Competition of High School (1995, rank 1 in Hunan Province, China)</li>
        <li>Outstanding Merit in the Chinese Mathematics Competition of High School (1994, rank 4 in Hunan Province, China)</li>
      </ol>
    </section>
    <section class="section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title margin-bottom-30px">Research Grants</h3></div>
      <el-divider content-position="left"><h4 class="fs-18 list-title">External</h4></el-divider>
      <ol class="text-normal list">
        <li>2008-2010, Co-I, HKRGC (F-HK05/08T), France/Hong Kong Joint Research Grant, HK$13,500.</li>
        <li>2009-2011, PI, HKRGC 203109, <em>Study on Dictionary Based Total Variation Model for Image Restoration</em>, HK$358,000.</li>
        <li>2010-2013, PI, HKRGC 211710, <em>Multiplicative Denoising and Deblurring</em>, HK$587,880.</li>
        <li>2011-2014, PI, HKRGC 211911, <em>Variational Models for Poisson Noise Removal and Deblurring</em>, HK$995,670.</li>
        <li>2013-2016, PI, NSF-China 11271049, <em>On Image Recovery under Non-Gaussian Noise</em>, RMB¥600,000.</li>
        <li>2014-2017, PI, HKRGC 12302714, <em>Variational Models in Image Segmentation: Theoretical issues and Applications</em>, HK$971,433.</li>
        <li>2017-2021, Co-I, NSF-China 11671002, <em>The Study of Variational Image Processing Models and Algorithms based on Patch Group Low Rank and Sparse Structures</em>, RMB¥480,000.</li>
        <li>2018-2019, PI, Industry 7010438, <em>The Next Structured Matrices Theoretical and Application Research</em>, HK$1,200,000.</li>
        <li>2019-2022, PI, HKRGC 14300219, <em>Novel Efficient Methods for Image Recovery Under Heavy Noise and Their Applications</em>, HK$502,444.</li>
        <li>2019-2023, PI, N_CUHK415/19, <em>Generative Adversarial Learning based Magnetic Resonance Image Enhancement: Modeling and Algorithm</em>, HK$906,446.</li>
        <li>2020-2023, Co-I, NSFC 61971234, <em>The Framework of Sparse Data Reconstruction and its Applications Based on Convex and Non-convex Strategies</em>, RMB¥650,000.</li>
        <li>2020-2022, PI, HKRGC 14302920, <em>Non-convex Optimization for Image Recovery: Modelling, Analysis, and Understanding</em>, HK$599,861.</li>
        <li>2020-2024, PI, Research Matching Grant Scheme, UGC, <em>Artificial Intelligence: Foundations, Theory, and Algorithms-RMG01</em>, HK$160, 000.</li>
      </ol>
      <el-divider content-position="left"><h4 class="fs-18 list-title">Internal</h4></el-divider>
      <ol class="text-normal list">
        <li>2009-2010, PI, HKBU FRG/08-09/II-36, <em>Total Variation Based Sparse Representation Model for Image Restoration</em>, HK$140,000.</li>
        <li>2010-2011, PI, HKBU FRG/09-10/II-41, <em>Proximal Point Algorithm for Image Processing</em>, HK$100,000.</li>
        <li>2014-2015, PI, HKBU FRG1/13-14/006, <em>Image Segmentation: Smoothing and Thresholding</em>, HK$50,000.</li>
        <li>2014-2015, PI, HKBU FRG2/13-14/068, <em>Sparse Representation and Nonnegative Matrix Factorization for Hyperspectral Imaging</em>, HK$105,000.</li>
        <li>2016-2017, PI, HKBU FRG2/15-16/076, <em>Low rank prior and total variation regularization for image deblurring</em>, HK$120,000.</li>
        <li>2018-2019, PI, CUHK DAG 4053296, <em>Regularization Methods in Image Processing</em>, HK$100,000.</li>
        <li>2019-2020, PI, CUHK DAG 4053342, <em>Critical Issues and Applications in Variational Approaches for Image Recovery</em>, HK$64,514.</li>
        <li>2020-2021, PI, CUHK DAG 4053342, <em>Novel Efficient Methods for Image Recovery Under Heavy Noise and Their Applications</em>, HK$29,121.</li>
      </ol>
    </section>
  </div>
</template>
<script type="text/javascript">
import SideIcons from '@/components/sideIcons/sideIcons'
export default {
  components: { SideIcons },
  data() {
    return {
      url: []
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.page {
  .section{
    padding-left: 10%;
    padding-right: 10%;
  }
  .list{
    padding: 10px 0 30px 60px;
    li{
      margin-bottom: 20px;
    }
  }
}
</style>
